<script setup lang="ts"></script>

<template>
  <p class="font-pragmatica-ext font-bold">
    <slot />
  </p>
</template>
